import store from '@/store';
import { getState } from '@/mocks/corporate/store';
import { isCorporateMockEnabled } from './environment';

/**
 * Contexto do portal corporativo: usuário real ou preview por setor.
 */
export function getPortalViewerContext() {
    const preview = store.state?.previewAs;
    const user = store.state?.user;

    if (preview?.enabled && preview.sectorId) {
        let enrolments = [];
        if (isCorporateMockEnabled()) {
            const match = (getState().users || []).find(
                (u) => u.sectorId === preview.sectorId,
            );
            enrolments = match?.enrolments || [];
        }
        return {
            isPreview: true,
            sectorId: preview.sectorId,
            roleId: preview.roleId || null,
            boardId: preview.boardId || null,
            sectorName: preview.sectorName || null,
            roleName: preview.roleName || null,
            enrolments,
            label: preview.sectorName || null,
        };
    }

    const sectorId = user?.sectorId || user?.corporateSectorId || null;
    const roleId = user?.roleId || user?.corporateRoleId || null;
    const boardId = user?.boardId || user?.corporateBoardId || null;
    let enrolments = user?.enrolments || [];

    if (isCorporateMockEnabled() && (!enrolments.length || !sectorId)) {
        const email = user?.email;
        const mockUser = (getState().users || []).find((u) => u.email === email)
            || (getState().users || []).find((u) => u.corporatePermission === 'colaborador');
        return {
            isPreview: false,
            sectorId: sectorId || mockUser?.sectorId || null,
            roleId: roleId || mockUser?.roleId || null,
            boardId: boardId || mockUser?.boardId || null,
            sectorName: null,
            roleName: null,
            enrolments: enrolments.length ? enrolments : (mockUser?.enrolments || []),
            label: null,
        };
    }

    return {
        isPreview: false,
        sectorId,
        roleId,
        boardId,
        sectorName: null,
        roleName: null,
        enrolments,
        label: null,
    };
}

/** Query params de preview para endpoints corporativos (cursos, acompanhamento). */
export function getPreviewQueryParams() {
    const ctx = getPortalViewerContext();
    if (!ctx.isPreview || !ctx.sectorId) {
        return {};
    }
    const params = { previewSectorId: ctx.sectorId };
    if (ctx.roleId) {
        params.previewRoleId = ctx.roleId;
    }
    return params;
}

export default {
    getPortalViewerContext,
    getPreviewQueryParams,
};
